// extracted by mini-css-extract-plugin
export default {"Switcher__container":"Switcher_Switcher__container__iSAaG"};